<template>
    <div class="stats-tab">
        <div class="game row">
            <div class="col col-2">
            </div>
            <div class="col col-3 tal">
                Result corresponds with highest probability
            </div>
        </div>
        <div class="game row">
            <div class="col col-2">
            </div>
            <div class="col col-3 oddsblocks">
                <div class="oddsblock correctGuess" style="width: 50%;">50 %</div>
                <div class="oddsblock tac" style="width: 30%;">30 %</div>
                <div class="oddsblock tar" style="width: 20%;">20 %</div>
            </div>
            <div class="col col-1">
                <div class="row">
                    <div class="col col-1 small-col-3 no-wrap icon-text result" title="Example result"> 1 - 0 </div>
                    <div class="col col-3"></div>
                </div>
            </div>
        </div>
        <div class="game row">
            <div class="col col-2">
                <div class="col col-6 tar">Final Lineup: </div>
            </div>
            <div class="col col-4">
                <div style="float: left; width: 60px;">{{ (numberOfCorrectPredictionsLU/numberOfGames*100).toFixed(1) }} %</div>
                <div style="float: left; width: 85px;">({{ numberOfCorrectPredictionsLU }} / {{ numberOfGames }})</div>
                <div class="col icon icon-block mpp_lineup" title="Probabilities are composed using actual lineup data"></div>                                    
            </div>
        </div>
        <div class="game row">
            <div class="col col-2">
                <div class="col col-6 tar">
                    <span class="full-text">Predicted missing players:</span>
                    <span class="short-text">Pred. missing Plrs:</span>
                </div>
            </div>
            <div class="col col-4">
                <div style="float: left; width: 60px;">{{ (numberOfCorrectPredictionsMPP/numberOfGames*100).toFixed(1) }} %</div>
                <div style="float: left; width: 85px;">({{ numberOfCorrectPredictionsMPP }} / {{ numberOfGames }})</div>
                <div class="icon icon-block mpp_predicted" title="Probabilities are composed using predicted missing player data"></div>                                    
            </div>  
        </div>
        <div class="game row">
            <div class="col col-2">
                <div class="col col-6 tar">No player data: </div>
            </div>
            <div class="col col-4">
                <div  style="float: left; width: 60px;">{{ (numberOfCorrectPredictionsBasic/numberOfGames*100).toFixed(1) }} %</div>
                <div  style="float: left; width: 85px;">({{ numberOfCorrectPredictionsBasic }} / {{ numberOfGames }})</div>
                <div class="icon icon-block mpp_na" title="Probabilities are composed without using player data"></div>                                    
            </div>  
        </div>
        <div class="game row">
            <div class="col col-6"><span class="tab"></span></div>
        </div>
        <div class="game row">
            <div class="col col-2">
            </div>
            <div class="col col-3 tal">
                Result corresponds with highest or second highest probability
            </div>
        </div>
        <div class="game row">
            <div class="col col-2">
            </div>
            <div class="col col-3 oddsblocks">
                <div class="oddsblock okGuess" style="width: 30%;">30 %</div>
                <div class="oddsblock tac" style="width: 50%;">50 %</div>
                <div class="oddsblock tar" style="width: 20%;">20 %</div>
            </div>
            <div class="col col-1">
                <div class="row">
                    <div class="col col-1 small-col-3 no-wrap icon-text result" title="Example result"> 1 - 0 </div>
                    <div class="col col-3"></div>
                </div>
            </div>
        </div>
<div class="game row">
            <div class="col col-2">
                <div class="col col-6 tar">Final Lineup: </div>
            </div>
            <div class="col col-4">
                <div style="float: left; width: 60px;">
                   {{ (numberOfCorrectPredictionsLUWithSecondary/numberOfGames*100).toFixed(1) }} %
                </div>
                <div style="float: left; width: 85px;">
                    ({{ numberOfCorrectPredictionsLUWithSecondary }} / {{ numberOfGames }})
                </div>
                <div class="icon icon-block mpp_lineup" title="Probabilities are composed using actual lineup data"></div>                                    
            </div>
        </div>
        <div class="game row">
            <div class="col col-2">
                <div class="col col-6 tar">
                    <span class="full-text">Predicted missing players:</span>
                    <span class="short-text">Pred. missing Plrs:</span>
                </div>
            </div>
            <div class="col col-4">
                <div style="float: left; width: 60px;">{{ (numberOfCorrectPredictionsMPPWithSecondary/numberOfGames*100).toFixed(1) }} %</div>
                <div style="float: left; width: 85px;">({{ numberOfCorrectPredictionsMPPWithSecondary }} / {{ numberOfGames }})</div>
                <div class="icon icon-block mpp_predicted" title="Probabilities are composed using predicted missing player data"></div>                                    
            </div>  
        </div>
        <div class="game row">
            <div class="col col-2">
                <div class="col col-6 tar">No player data: </div>
            </div>
            <div class="col col-4">
                <div style="float: left; width: 60px;">{{ (numberOfCorrectPredictionsBasicWithSecondary/numberOfGames*100).toFixed(1) }} %</div>
                <div style="float: left; width: 85px;">({{ numberOfCorrectPredictionsBasicWithSecondary }} / {{ numberOfGames }})</div>
                <div class="icon icon-block mpp_na" title="Probabilities are composed without using player data"></div>                                    
            </div>  
        </div>
        <div class="game row">
            <div class="col col-6"><span class="tab"></span></div>
        </div>
        <div class="game row">
            <div class="col col-2">
            </div>
            <div class="col col-3 tal">
                Average Probability For Correct Result            
            </div>
        </div>
        <div class="game row">
            <div class="col col-2">
                <div class="col col-6 tar">Final Lineup: </div>
            </div>
            <div class="col col-4">
                <div style="float: left; width: 60px;">
                   {{ averageProbabilityForResultLU.toFixed(2) }} %
                </div>
                <div style="float: left; width: 85px;">
                    <span class="tab"></span>
                </div>
                <div class="icon icon-block mpp_lineup" title="Probabilities are composed using actual lineup data"></div>                                    
            </div>
        </div>
        <div class="game row">
            <div class="col col-2">
                <div class="col col-6 tar">
                    <span class="full-text">Predicted missing players:</span>
                    <span class="short-text">Pred. missing Plrs:</span>
                </div>
            </div>
            <div class="col col-4">
                <div style="float: left; width: 60px;">{{ averageProbabilityForResultMPP.toFixed(2) }} %</div>
                <div style="float: left; width: 85px;"><span class="tab"></span></div>
                <div class="icon icon-block mpp_predicted" title="Probabilities are composed using predicted missing player data"></div>                                    
            </div>  
        </div>
        <div class="game row">
            <div class="col col-2">
                <div class="col col-6 tar">No player data: </div>
            </div>
            <div class="col col-4">
                <div style="float: left; width: 60px;">{{ averageProbabilityForResultBasic.toFixed(2) }} %</div>
                <div style="float: left; width: 85px;"><span class="tab"></span></div>
                <div class="icon icon-block mpp_na" title="Probabilities are composed without using player data"></div>                                    
            </div>  
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            selectedLeague : {
                type: String,
                required: true
            },
            activeGames : {
                type: Array,
                required: true
            }
        },
        computed : {
            numberOfGames() {
                return this.activeGames.length;
            },
            numberOfCorrectPredictionsLU() {
                let tmp = this.activeGames;
                tmp = tmp.filter(game => {
                    return (((game.homeOdds_lu_actual > game.drawOdds_lu_actual && game.homeOdds_lu_actual > game.awayOdds_lu_actual) && game.homeGoals > game.awayGoals) || ((game.awayOdds_lu_actual > game.drawOdds_lu_actual && game.awayOdds_lu_actual > game.homeOdds_lu_actual) && game.homeGoals < game.awayGoals) || ((game.drawOdds_lu_actual > game.homeOdds_lu_actual && game.drawOdds_lu_actual > game.awayOdds_lu_actual) && game.homeGoals == game.awayGoals))
                })
                return tmp.length;
            },
            numberOfCorrectPredictionsMPP() {
                let tmp = this.activeGames;
                tmp = tmp.filter(game => {
                    return (((game.homeOdds_lu_mpp > game.drawOdds_lu_mpp && game.homeOdds_lu_mpp > game.awayOdds_lu_mpp) && game.homeGoals > game.awayGoals) || ((game.awayOdds_lu_mpp > game.drawOdds_lu_mpp && game.awayOdds_lu_mpp > game.homeOdds_lu_mpp) && game.homeGoals < game.awayGoals) || ((game.drawOdds_lu_mpp > game.homeOdds_lu_mpp && game.drawOdds_lu_mpp > game.awayOdds_lu_mpp) && game.homeGoals == game.awayGoals))
                })
                return tmp.length;
            },
            numberOfCorrectPredictionsBasic() {
                let tmp = this.activeGames;
                tmp = tmp.filter(game => {
                    return (((game.homeOdds_lu_basic > game.drawOdds_lu_basic && game.homeOdds_lu_basic > game.awayOdds_lu_basic) && game.homeGoals > game.awayGoals) || ((game.awayOdds_lu_basic > game.drawOdds_lu_basic && game.awayOdds_lu_basic > game.homeOdds_lu_basic) && game.homeGoals < game.awayGoals) || ((game.drawOdds_lu_basic > game.homeOdds_lu_basic && game.drawOdds_lu_basic > game.awayOdds_lu_basic) && game.homeGoals == game.awayGoals))
                })
                return tmp.length;
            },
            numberOfCorrectPredictionsLUWithSecondary() {
                let tmp = this.activeGames;
                tmp = tmp.filter(game => {
                    return (((game.homeOdds_lu_actual >= game.drawOdds_lu_actual || game.homeOdds_lu_actual >= game.awayOdds_lu_actual) && game.homeGoals > game.awayGoals) || ((game.awayOdds_lu_actual >= game.drawOdds_lu_actual || game.awayOdds_lu_actual >= game.homeOdds_lu_actual) && game.homeGoals < game.awayGoals) || ((game.drawOdds_lu_actual >= game.homeOdds_lu_actual || game.drawOdds_lu_actual >= game.awayOdds_lu_actual) && game.homeGoals == game.awayGoals))
                })
                return tmp.length;
            },
            numberOfCorrectPredictionsMPPWithSecondary() {
                let tmp = this.activeGames;
                tmp = tmp.filter(game => {
                    return (((game.homeOdds_lu_mpp >= game.drawOdds_lu_mpp || game.homeOdds_lu_mpp >= game.awayOdds_lu_mpp) && game.homeGoals > game.awayGoals) || ((game.awayOdds_lu_mpp >= game.drawOdds_lu_mpp || game.awayOdds_lu_mpp >= game.homeOdds_lu_mpp) && game.homeGoals < game.awayGoals) || ((game.drawOdds_lu_mpp >= game.homeOdds_lu_mpp || game.drawOdds_lu_mpp >= game.awayOdds_lu_mpp) && game.homeGoals == game.awayGoals))
                })
                
                return tmp.length;
            },
            numberOfCorrectPredictionsBasicWithSecondary() {
                let tmp = this.activeGames;
                tmp = tmp.filter(game => {
                    return (((game.homeOdds_lu_basic >= game.drawOdds_lu_basic || game.homeOdds_lu_basic >= game.awayOdds_lu_basic) && game.homeGoals > game.awayGoals) || ((game.awayOdds_lu_basic >= game.drawOdds_lu_basic || game.awayOdds_lu_basic >= game.homeOdds_lu_basic) && game.homeGoals < game.awayGoals) || ((game.drawOdds_lu_basic >= game.homeOdds_lu_basic || game.drawOdds_lu_basic >= game.awayOdds_lu_basic) && game.homeGoals == game.awayGoals))
                })
                
                return tmp.length;
            },
            averageProbabilityForResultLU() {
                let tmp = this.activeGames;
                let sum = 0;
                tmp.forEach(game => {
                    if ( game.awayOdds_lu_actual != undefined) {
                        if (game.homeGoals > game.awayGoals) {
                            sum += game.homeOdds_lu_actual;
                        } else if ( game.homeGoals == game.awayGoals ) {
                            sum += game.drawOdds_lu_actual;
                        } else {
                            sum += game.awayOdds_lu_actual;
                        }
                    }
                });
                return sum/tmp.length;
            },
            averageProbabilityForResultMPP() {
                let tmp = this.activeGames;
                let sum = 0;
                tmp.forEach(game => {
                    if ( game.awayOdds_lu_mpp != undefined) {
                        if (game.homeGoals > game.awayGoals) {
                            sum += game.homeOdds_lu_mpp;
                        } else if ( game.homeGoals == game.awayGoals ) {
                            sum += game.drawOdds_lu_mpp;
                        } else {
                            sum += game.awayOdds_lu_mpp;
                        }
                    }
                });
                return sum/tmp.length;
            },
            averageProbabilityForResultBasic() {
                let tmp = this.activeGames;
                let sum = 0;
                tmp.forEach(game => {
                    if ( game.awayOdds_lu_basic != undefined) {
                        if (game.homeGoals > game.awayGoals) {
                            sum += game.homeOdds_lu_basic;
                        } else if ( game.homeGoals == game.awayGoals ) {
                            sum += game.drawOdds_lu_basic;
                        } else {
                            sum += game.awayOdds_lu_basic;
                        }
                    }
                });
                return sum/tmp.length;
            },
        }
    }
</script>
<style scoped>
    .tab {
        margin: 0 1em;
        min-height: 1em;
    }
</style>